export const Email = /^[\w.+\-=-]+@[\w.-]+\.[\w]{2,25}$/;
export const AxaMembershipNumber = /^([Aa]{1}[Xx]{1}[Aa]{1}[/]{1}[A-Za-z]{1}[0-9]{7})/;
export const HolMembershipNumber = /^([Hh]{1}[oO]{1}[Ll]{1}[/]{1}[A-Za-z]{1}[0-9]{7})$/;
export const CrestMembershipNumber = /^[0-9]{7}[A-Za-z]{1}$/;
export const CrestMembershipNumberWithLetters = /^[A-Za-z]{2}[0-9]{7}[A-Za-z]{1}$/;
export const PostCode = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$/;
